import React, { useContext } from 'react'
import classnames from 'classnames'
import { useHistory } from 'react-router-dom'
import { Container, Navbar, Row } from 'react-bootstrap'
import { useUserService, ABTooltip, AbroadIconForSM } from '@abroad/components'
import { LayoutContext } from '../../utils/contexts'

/**
 * Top header: collapse / mobile chrome only.
 * Search + profile live in the sidebar foot (v7 gnav).
 */
const Header = () => {
  const { showSidebar, setShowSidebar } = useContext(LayoutContext)
  const history = useHistory()
  const { user } = useUserService()

  // Desktop: hide this chrome when the gnav is open. An empty Navbar still
  // keeps Bootstrap padding (~16px), which is the gap under the page head.
  const showDesktopChrome = !showSidebar

  return (
    <Container
      fluid
      className={classnames('px-0', {
        // Keep the mobile bar (open/close); drop the empty desktop strip.
        'd-lg-none': showSidebar,
      })}>
      <Row className='m-0'>
        <div className='custom-col-12 custom-offset-lg-1 px-0'>
          {showDesktopChrome ? (
            <Navbar className='d-none d-lg-flex nav-header px-0 py-0'>
              <Navbar.Brand className='position-fixed pl-0 d-lg-flex'>
                <svg
                  onClick={() => setShowSidebar(true)}
                  className='cursor-pointer'
                  xmlns='http://www.w3.org/2000/svg'
                  width='35.751'
                  height='17.992'
                  viewBox='0 0 35.751 17.992'
                  aria-label='Open menu'>
                  <defs>
                    <style>
                      {`.header-a{fill:none;stroke:#959595;stroke-linecap:round;stroke-width:1.5px;}`}
                    </style>
                  </defs>
                  <g transform='translate(-26.494 -22.504)'>
                    <line
                      className='header-a'
                      x2='21.99'
                      transform='translate(32.505 23.254)'
                    />
                    <line
                      className='header-a'
                      x2='21.99'
                      transform='translate(32.505 31.5)'
                    />
                    <line
                      className='header-a'
                      x2='21.99'
                      transform='translate(32.505 39.746)'
                    />
                  </g>
                </svg>
              </Navbar.Brand>
            </Navbar>
          ) : null}
          {/* Mobile header — hamburger opens the full-screen gnav drawer */}
          <Navbar
            fixed='top'
            className='d-flex d-lg-none bg-gray-104 align-items-center'>
            <Navbar.Brand className='mr-0 leading-none'>
              <AbroadIconForSM
                onClick={() => history.push('/admin/home')}
                className='pointer-cursor abroad-sm-icon'
              />
            </Navbar.Brand>
            <Navbar.Collapse className='position-relative justify-content-end'>
              <Navbar.Text className='d-flex align-items-center'>
                {user?.isAdmin ? (
                  <ABTooltip
                    customPlacement
                    placement='bottom-end'
                    controllId='header-tooltip'
                    contentText='Using the top section of our Menu, you can access all of the features across our entire platform'
                    className='xs-header-tooltip-icon'
                  />
                ) : null}
                <svg
                  onClick={() => setShowSidebar(true)}
                  className={classnames('cursor-pointer', {
                    'd-none': showSidebar,
                  })}
                  xmlns='http://www.w3.org/2000/svg'
                  width='35.751'
                  height='17.992'
                  viewBox='0 0 35.751 17.992'
                  aria-label='Open menu'>
                  <defs>
                    <style>
                      {`.header-sm-a{fill:none;stroke:#000;stroke-linecap:round;stroke-width:1.5px;}`}
                    </style>
                  </defs>
                  <g transform='translate(-26.494 -22.504)'>
                    <line
                      className='header-sm-a'
                      x2='21.99'
                      transform='translate(32.505 23.254)'
                    />
                    <line
                      className='header-sm-a'
                      x2='21.99'
                      transform='translate(32.505 31.5)'
                    />
                    <line
                      className='header-sm-a'
                      x2='21.99'
                      transform='translate(32.505 39.746)'
                    />
                  </g>
                </svg>

                <svg
                  onClick={() => setShowSidebar(false)}
                  className={classnames('cursor-pointer ml-4', {
                    'd-none': !showSidebar,
                  })}
                  xmlns='http://www.w3.org/2000/svg'
                  width='26.615'
                  height='22.615'
                  viewBox='0 0 26.615 22.615'
                  aria-label='Close menu'>
                  <defs>
                    <style>
                      {`.arrow-a{fill:none;stroke:#000;stroke-linecap:round;stroke-width:2px;}`}
                    </style>
                  </defs>
                  <g transform='translate(-330.192 -30.192)'>
                    <line
                      className='arrow-a'
                      x1='24'
                      y1='10'
                      transform='translate(331.5 41.5)'
                    />
                    <line
                      className='arrow-a'
                      x1='24'
                      y2='10'
                      transform='translate(331.5 31.5)'
                    />
                  </g>
                </svg>
              </Navbar.Text>
            </Navbar.Collapse>
          </Navbar>
        </div>
      </Row>
    </Container>
  )
}

export default Header
